import styled from 'styled-components';

export const HeadingWrapper = styled.h2`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    font-size: 0.9rem;
    font-weight: 500;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
    background: ${({ theme }) => theme.colors.background.header};
    cursor: pointer;
`;

export const LeftWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
`;

export const RightWrapper = styled.div`
    flex: 0 0 auto;
`;

export const RelativeWrapper = styled.div`
    position: relative;
`;
